import React, { useState, useRef, useMemo } from 'react'
import styled from '@emotion/styled'
import { flattenDeep } from 'lodash-es'
// import UserProvider from './hooks/user/provider'
import UserGroup from './Sidebar'
import UserTable from './components/user/table/UsersTable'
import TableHeader from './components/group/operateHeader'
import useOrg from './hooks/org/use-org'
import useUser from './hooks/user/use-users'

const borderColor = '#dbdfea'
const Container = styled.div`
  flex: 1 1 0%;
  padding: 18px;
`
const GroupContent = styled.div`
  border: 1px solid ${borderColor};
  background-color: #fff;
  border-radius: 4px;
`

const UsersContent = styled.div`
  border: 1px solid ${borderColor};
  background-color: #fff;
  border-radius: 4px;
`

const Users = function ({
  appId,
  currentOrg,
  currentGroup,
  searchData,
  useOrgApi,
}) {
  const useUserApi = useUser(appId, currentOrg, currentGroup, searchData)
  const { showUsers, checkedUsers, fetchUsers, onCheckedUsers } = useUserApi
  const { customInfo, orgs } = useOrgApi
  const getFilterOrgIds = (data) => {
    return data.map((item) => {
      let arr = []
      if (item.children) arr = getFilterOrgIds(item.children)
      return [...arr, item.id]
    })
  }
  const _showUsers = useMemo(() => {
    if (customInfo && customInfo.orgSlug && showUsers.length && orgs.length) {
      const filterOrgIds = flattenDeep(getFilterOrgIds(orgs))
      return showUsers.filter((f) => filterOrgIds.includes(f.orgId))
    }
    return showUsers
  }, [customInfo, showUsers, orgs])

  const tableRef = useRef()
  return (
    <UsersContent className="h-full w-full sm:w-full md:w-4/5 flex flex-col items-center">
      <TableHeader
        appId={appId}
        length={_showUsers.length}
        checkedUsers={checkedUsers}
        // cancleSeletedUsers={cancleSeletedUsers}
        usersMutate={fetchUsers}
        useOrg={useOrgApi}
        useUserApi={useUserApi}
      />
      <UserTable
        users={_showUsers}
        fetchUsers={fetchUsers}
        updateCheckedUser={onCheckedUsers}
        tableRef={tableRef}
        useUserApi={useUserApi}
      />
    </UsersContent>
  )
}

const Index = function ({ appId }) {
  // 搜索用户、组织
  const [searchData, setSearchData] = useState('')
  // 组织、分组
  const useOrgApi = useOrg(appId)
  const { currentOrg, currentGroup } = useOrgApi

  // const [checkedUsers, setCheckedUsers] = useState([])
  // 当前要展示的用户
  // const [showUsers, setShowUsers] = useState(allUsers || [])

  return (
    <Container className="h-full w-full flex flex-col md:flex-row overflow-hidden gap-4">
      <GroupContent className="h-full w-full sm:w-full md:w-1/5 flex items-center flex-col overflow-auto">
        <UserGroup
          appId={appId}
          searchData={searchData}
          updateSearchData={(v) => {
            setSearchData(v)
          }}
          useOrg={useOrgApi}
        />
      </GroupContent>
      {/* <UserProvider appId={appId}> */}
      <Users
        appId={appId}
        currentOrg={currentOrg}
        currentGroup={currentGroup}
        searchData={searchData}
        useOrgApi={useOrgApi}
      />
      {/* </UserProvider> */}
    </Container>
  )
}
export default Index
